<template>
  <div>
    <div class="row">
      <div class="col-xl-4 col-lg-6 col-md-12">
        <account-details/>
      </div>
      <div class="col-xl-4 col-lg-6 col-md-12"
           v-if="accountLoaded() && account.status != 'deleted' && (account.type === 'card')  && $auth.can({account_props: 'read'}, 'permissions')">
        <div>
          <account-additional-details/>
        </div>
      </div>
      <div class="col-xl-4 col-lg-6 col-md-12"
           v-if="accountLoaded() && account.status != 'deleted'">
        <div>
          <account-card-details :account-id="account.id" v-if="account.type === 'card' || account.type === 'emv_card'"/>
        </div>
        <div>
          <account-props
            v-if="account.type !== 'emv_card' && $auth.can({account_props: 'read'}, 'permissions')"/>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-6 col-md-12" v-if="accountLoaded() && account.status == 'deleted'">
        <account-deleted-view :account-id="account.id"/>
      </div>
    </div>

    <div class="row">
      <div v-if="accountLoading" class="col-12">
        <loading-panel/>
      </div>
      <div v-else-if="accountLoaded()" class="col-12">
        <div v-if="account.status == 'deleting' " class="row">
          <div class="col-12">
            <account-deleting-view :account-id="$route.params.id"/>
          </div>
        </div>

        <!-- Pages -->
        <account-money-claim v-if="$route.name == 'account-money-claims-details'" :account-id="$route.params.id"
                             :money-claim-id="$route.params.money_claim_id"/>
<!--        <account-purchase v-if="$route.name == 'account-purchase-details'" :account-id="$route.params.id"-->
<!--                          :resource-id="$route.params.resource_id"/>-->
        <account-tap v-if="$route.name == 'account-tap-details'" :account-id="$route.params.id"
                     :resource-id="$route.params.resource_id"/>
        <account-top-up v-if="$route.name == 'account-top-ups-details'" :account-id="$route.params.id"
                        :top-up-id="$route.params.top_up_id"/>
        <account-journey v-if="$route.name == 'account-journey-details'" :account-id="$route.params.id"
                         :journey-id="$route.params.journey_id"/>
        <account-season-ticket v-if="$route.name == 'account-season-ticket'" :account-id="$route.params.id"
                               :account-season-ticket-id="$route.params.season_ticket_id"/>
        <account-emv-tap v-if="$route.name == 'account-emv-tap-details'" :account-id="$route.params.id"
                         :resource-id="$route.params.resource_id"/>
        <account-emv-clearing v-if="$route.name == 'account-emv-clearing'" :account-id="$route.params.id"
                              :resource-id="$route.params.resource_id"/>
        <account-audit-log v-if="$route.name == 'account-audit-log-details'" :account-id="$route.params.id"
                           :resource-id="$route.params.resource_id"/>

        <!-- Tabs -->
        <tabs
          :square="true"
          :value="currentView"
          v-show="showTabsPane()"
          :handle-click="handleClick">
          <tab-pane v-if="$auth.can({account_journey: 'read'}, 'permissions')" :label="$t('accountProfile.journeysTab')"
                    name="account-journeys">
            <account-journeys v-if="$route.name == 'account-journeys' || $route.name == 'account-journey-details'"
                              :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_season_tickets: 'read'}, 'permissions')"
                    :label="$t('accountProfile.accountSeasonTicketsTab')" name="account-season-tickets">
            <account-season-tickets
              v-if="$route.name == 'account-season-tickets' || $route.name == 'account-season-ticket'"
              :active-account-discount="account.discount_id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_top_up: 'read'}, 'permissions')" :label="$t('accountProfile.topUpsTab')"
                    name="account-top-ups">
            <account-top-ups v-if="$route.name == 'account-top-ups' || $route.name == 'account-top-ups-details'"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_money_claim: 'read'}, 'permissions')"
                    :label="$t('accountProfile.moneyClaimsTab')" name="account-money-claims">
            <account-money-claims
              v-if="$route.name == 'account-money-claims' || $route.name == 'account-money-claims-details'"
              :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_pos_operation: 'read'}, 'permissions')"
                    :label="$t('accountProfile.accountPosOperationsTab')" name="account-pos-operations">
            <account-pos-operations v-if="$route.name == 'account-pos-operations'"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_credit_debit_log: 'read'}, 'permissions')"
                    :label="$t('accountProfile.creditsDebitsTab')" name="credit-debit-logs">
            <account-credit-debit-logs v-if="$route.name == 'credit-debit-logs'" :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_payment_card: 'read'}, 'permissions')"
                    :label="$t('accountProfile.paymentCardsTab')" name="account-payment-cards">
            <account-payment-cards v-if="$route.name == 'account-payment-cards'" :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_payment_card_creation: 'read'}, 'permissions')"
                    :label="$t('accountProfile.paymentCardCreationsTab')" name="account-payment-card-creations">
            <account-payment-card-creations v-if="$route.name == 'account-payment-card-creations'"
                                            :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_inspection_event: 'read'}, 'permissions')"
                    :label="$t('accountProfile.accountInspectionEventsTab')" name="account-inspection-events">
            <account-inspection-events v-if="$route.name == 'account-inspection-events'"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_tap: 'read'}, 'permissions')"
                    :label="$t('accountProfile.tapsTab')"
                    name="account-taps">
            <account-taps v-if="$route.name == 'account-taps' || $route.name == 'account-tap-details'"
                          :account-type="account.type"/>
          </tab-pane>
<!--          <tab-pane v-if="$auth.can({account_purchase: 'read'}, 'permissions')"-->
<!--                    :label="$t('accountProfile.purchasesTab')"-->
<!--                    name="account-purchases">-->
<!--            <account-purchases v-if="$route.name == 'account-purchases' || $route.name == 'account-purchase-details'"/>-->
<!--          </tab-pane>-->
          <tab-pane v-if="$auth.can({account_discount: 'read'}, 'permissions')"
                    :label="$t('accountProfile.discountsTab')" name="account-discounts">
            <account-discounts v-if="$route.name == 'account-discounts'" :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_municipality: 'read'}, 'permissions')"
                    :label="$t('accountProfile.municipalitiesTab')" name="account-municipalities">
            <account-municipalities v-if="$route.name == 'account-municipalities'" :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_email: 'read'}, 'permissions')"
                    :label="$t('accountProfile.emailsTab')" name="account-emails">
            <account-emails v-if="$route.name == 'account-emails'" :account-id="$route.params.id"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_mobile_device: 'read'}, 'permissions')"
                    :label="$t('accountProfile.mobileDevicesTab')" name="account-mobile-devices">
            <account-mobile-devices v-if="$route.name == 'account-mobile-devices'" :account-id="$route.params.id"
                                    :account-type="account.type"/>
          </tab-pane>
          <tab-pane v-if="isEmvAccount() && $auth.can({account_emv_tap: 'read'}, 'permissions')" :label="$t('accountProfile.emvTapsTab')"
                    name="account-emv-taps">
            <account-emv-taps v-if="$route.name == 'account-emv-taps' || $route.name == 'account-emv-taps-details'"/>
          </tab-pane>
          <tab-pane v-if="isEmvAccount() &&  $auth.can({account_emv_clearing: 'read'}, 'permissions')"
                    :label="$t('accountProfile.emvClearingsTab')"
                    name="account-emv-clearings">
            <account-emv-clearings
              v-if="$route.name == 'account-emv-clearings' || $route.name == 'account-emv-clearing'"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_associations: 'read'}, 'permissions')"
                    :label="$t('accountProfile.associationsTab')"
                    name="account-associations">
            <account-associations v-if="$route.name == 'account-associations' || $route.name == 'account-association'"/>
          </tab-pane>
          <tab-pane v-if="$auth.can({account_audit_log: 'read'}, 'permissions')"
                    :label="$t('accountProfile.auditLogsTab')" name="account-audit-logs">
            <account-audit-logs
              v-if="$route.name == 'account-audit-logs' || $route.name == 'account-audit-log-details'"/>
          </tab-pane>
        </tabs>
      </div>
    </div>
  </div>
</template>
<script>
import {TabPane, Tabs} from 'src/components';
import AccountJourneys from './AccountDetails/AccountJourneys.vue';
import AccountJourney from './AccountDetails/AccountJourney.vue';
import AccountPurchases from './AccountDetails/AccountPurchases.vue';
import AccountPurchase from './AccountDetails/AccountPurchase.vue';
import AccountTaps from './AccountDetails/AccountTaps.vue';
import AccountTap from './AccountDetails/AccountTap.vue';
import AccountTopUps from './AccountDetails/AccountTopUps.vue';
import AccountTopUp from './AccountDetails/AccountTopUp.vue';
import AccountDetails from './AccountDetails/AccountDetails.vue';
import AccountMoneyClaims from './AccountDetails/AccountMoneyClaims.vue';
import AccountMoneyClaim from './AccountDetails/AccountMoneyClaim.vue'
import AccountDeletingView from "./AccountDetails/AccountDeletingView";
import AccountDeletedView from "./AccountDetails/AccountDeletedView";
import AccountDiscounts from "./AccountDetails/AccountDiscounts";
import AccountMunicipalities from "./AccountDetails/AccountMunicipalities.vue";
import AccountPaymentCards from "./AccountDetails/AccountPaymentCards";
import AccountPaymentCardCreations from "./AccountDetails/AccountPaymentCardCreations";
import AccountMobileDevices from "./AccountDetails/AccountMobileDevices";
import AccountCreditDebitLogs from "./AccountDetails/AccountCreditDebitLogs";
import AccountAuditLogs from "./AccountDetails/AccountAuditLogs";
import AccountAuditLog from "./AccountDetails/AccountAuditLog";
import AccountEmails from "./AccountDetails/AccountEmails";
import AccountSeasonTickets from "./AccountDetails/AccountSeasonTickets";
import AccountSeasonTicket from "./AccountDetails/AccountSeasonTicket";
import AccountPosOperations from "./AccountDetails/AccountPosOperations";
import AccountAdditionalDetails from "./AccountDetails/AccountAdditionalDetails";
import AccountProps from "./AccountDetails/AccountProps";
import AccountCardDetails from "./AccountDetails/AccountCardDetails";
import LoadingPanel from "src/components/LoadingPanel";
import AccountInspectionEvents from "@/pages/Account/AccountDetails/AccountInspectionEvents";
import AccountEmvTaps from "@/pages/Account/AccountDetails/AccountEmvTaps";
import AccountEmvTap from "@/pages/Account/AccountDetails/AccountEmvTap";
import AccountEmvClearings from './AccountDetails/AccountEmvClearings.vue';
import AccountEmvClearing from './AccountDetails/AccountEmvClearing.vue';
import AccountAssociations from './AccountDetails/AccountAssociations.vue';
import {mapState} from "vuex";

export default {
  components: {
    AccountEmvTaps,
    AccountEmvTap,
    AccountEmvClearings,
    AccountEmvClearing,
    AccountInspectionEvents,
    LoadingPanel,
    Tabs,
    TabPane,
    AccountJourneys,
    AccountJourney,
    AccountPurchases,
    AccountPurchase,
    AccountTaps,
    AccountTap,
    AccountTopUps,
    AccountTopUp,
    AccountDetails,
    AccountMoneyClaims,
    AccountMoneyClaim,
    AccountDeletingView,
    AccountDeletedView,
    AccountDiscounts,
    AccountMunicipalities,
    AccountPaymentCards,
    AccountPaymentCardCreations,
    AccountMobileDevices,
    AccountCreditDebitLogs,
    AccountAuditLogs,
    AccountAuditLog,
    AccountEmails,
    AccountSeasonTickets,
    AccountSeasonTicket,
    AccountPosOperations,
    AccountAdditionalDetails,
    AccountProps,
    AccountCardDetails,
    AccountAssociations
  },
  computed: {
    ...mapState({
      accountLoading: state => state.account.loading,
      account: state => state.account.data,
      accountID: state => state.account.id,
      error: state => state.account.error,
    }),
    currentView() {
      return this.$route.name
    },
  },
  methods: {
    isEmvAccount() {
      return this.account.type != 'card' && this.account.type != 'mobile';
    },
    showTabsPane() {
      return this.$route.name != 'account-journey-details' &&
        this.$route.name != 'account-money-claims-details' &&
        this.$route.name != 'account-top-ups-details' &&
        this.$route.name != 'account-emv-tap-details' &&
        this.$route.name != 'account-emv-clearing' &&
        this.$route.name != 'account-season-ticket' &&
        this.$route.name != 'account-purchase-details' &&
        this.$route.name != 'account-audit-log-details' &&
        this.$route.name != 'account-tap-details';
    },
    accountLoaded() {
      if (this.accountID == this.$route.params.id) {
        return true
      }
      return false
    },
    handleClick(tab, event) {
      switch (tab.name) {
        case 'account-journeys':
          this.$router.push({name: 'account-journeys', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-purchases':
          this.$router.push({name: 'account-purchases', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-taps':
          this.$router.push({name: 'account-taps', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-top-ups':
          this.$router.push({name: 'account-top-ups', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-money-claims':
          this.$router.push({name: 'account-money-claims', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-discounts':
          this.$router.push({name: 'account-discounts', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-municipalities':
          this.$router.push({name: 'account-municipalities', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-payment-cards':
          this.$router.push({name: 'account-payment-cards', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-payment-card-creations':
          this.$router.push({
            name: 'account-payment-card-creations',
            params: {id: this.$route.params.id}
          }).catch(err => {
          });
          break;
        case 'account-mobile-devices':
          this.$router.push({name: 'account-mobile-devices', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'credit-debit-logs':
          this.$router.push({name: 'credit-debit-logs', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-associations':
          this.$router.push({name: 'account-associations', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-audit-logs':
          this.$router.push({name: 'account-audit-logs', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-emails':
          this.$router.push({name: 'account-emails', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-season-tickets':
          this.$router.push({name: 'account-season-tickets', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-pos-operations':
          this.$router.push({name: 'account-pos-operations', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-inspection-events':
          this.$router.push({name: 'account-inspection-events', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-emv-taps':
          this.$router.push({name: 'account-emv-taps', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
        case 'account-emv-clearings':
          this.$router.push({name: 'account-emv-clearings', params: {id: this.$route.params.id}}).catch(err => {
          });
          break;
      }
    }
  }
};
</script>
<style></style>
